import { render, staticRenderFns } from "./cloudflare_pages_component.vue?vue&type=template&id=71b51b87&scoped=true&"
import script from "./cloudflare_pages_component.vue?vue&type=script&lang=js&"
export * from "./cloudflare_pages_component.vue?vue&type=script&lang=js&"
import style0 from "./cloudflare_pages_component.vue?vue&type=style&index=0&id=71b51b87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b51b87",
  null
  
)

export default component.exports